module.exports = __webpack_public_path__ + "static/img/2012@2x.0cc7622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/2012@2x.png
// module id = W4FN
// module chunks = 0